/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/race_condition_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./race_condition_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.RaceConditionServiceClient =
  function RaceConditionServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.RaceConditionServicePromiseClient =
  function RaceConditionServicePromiseClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullRaceConditionsRequest,
 *   !proto.stronachgroup.first.racehorse360.PullRaceConditionsResponse>}
 */
const methodDescriptor_RaceConditionService_PullRaceConditions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.RaceConditionService/PullRaceConditions",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullRaceConditionsRequest,
    stronachgroup_first_racehorse360_messages_pb.PullRaceConditionsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullRaceConditionsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullRaceConditionsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullRaceConditionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullRaceConditionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullRaceConditionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.RaceConditionServiceClient.prototype.pullRaceConditions =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceConditionService/PullRaceConditions",
      request,
      metadata || {},
      methodDescriptor_RaceConditionService_PullRaceConditions,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullRaceConditionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullRaceConditionsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.RaceConditionServicePromiseClient.prototype.pullRaceConditions =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceConditionService/PullRaceConditions",
      request,
      metadata || {},
      methodDescriptor_RaceConditionService_PullRaceConditions
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest,
 *   !proto.stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse>}
 */
const methodDescriptor_RaceConditionService_PullRaceConditionsForHorse =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.RaceConditionService/PullRaceConditionsForHorse",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullRaceConditionsForHorseRequest,
    stronachgroup_first_racehorse360_messages_pb.PullRaceConditionsForHorseResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullRaceConditionsForHorseResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.RaceConditionServiceClient.prototype.pullRaceConditionsForHorse =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceConditionService/PullRaceConditionsForHorse",
      request,
      metadata || {},
      methodDescriptor_RaceConditionService_PullRaceConditionsForHorse,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.RaceConditionServicePromiseClient.prototype.pullRaceConditionsForHorse =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceConditionService/PullRaceConditionsForHorse",
      request,
      metadata || {},
      methodDescriptor_RaceConditionService_PullRaceConditionsForHorse
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest,
 *   !proto.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse>}
 */
const methodDescriptor_RaceConditionService_PullRaceConditionsFacilities =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.RaceConditionService/PullRaceConditionsFacilities",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullRaceConditionsFacilitiesRequest,
    stronachgroup_first_racehorse360_messages_pb.PullRaceConditionsFacilitiesResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullRaceConditionsFacilitiesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.RaceConditionServiceClient.prototype.pullRaceConditionsFacilities =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceConditionService/PullRaceConditionsFacilities",
      request,
      metadata || {},
      methodDescriptor_RaceConditionService_PullRaceConditionsFacilities,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.RaceConditionServicePromiseClient.prototype.pullRaceConditionsFacilities =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceConditionService/PullRaceConditionsFacilities",
      request,
      metadata || {},
      methodDescriptor_RaceConditionService_PullRaceConditionsFacilities
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
